<template>
    <div class="title-group-page">
        <div class="search-wrapper">
            <div class="title"><a-icon type="search" /> 数据筛选</div>
            <a-divider></a-divider>
            <a-space>
                <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
                <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                    {{ corporation.name }}
                </a-select-option>
                </a-select>
                <a-input allow-clear placeholder="标题组名称" v-model="queryParam.name" />
                <byted-range-picker
                  v-model="queryParam.date"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :shortcuts="shortcutsR"
                  editable
                  :transfer="true"
                  :placeholder="['请选择开始日期', '请选择结束日期']"
                >
                </byted-range-picker>
                <a-button type="primary" @click="search">查询</a-button>
                <a-button @click="resetSearch">重置</a-button>
            </a-space>
        </div>

        <a-space class="table-operator">
            <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加标题组</a-button>
        </a-space>

        <a-tabs v-model="key" type="editable-card" hide-add default-active-key="tableGrid.data[0].id" @edit="onEdit" @change="callback">
            <a-tab-pane
                v-for="category in tableGrid.data"
                :key="category.id"
                :tab="category.name"
                >
                
                <vxe-grid
                    :ref="'grid_' + category.id"
                    class="table-scrollbar"
                    v-bind="tableGrid"
                    @page-change="handlePageChange"
                    :row-selection="rowSelection"
                    :data="currentData"
                    :loading="loading"
                    @checkbox-all="handleRowChange"
                    style="height: 500px;"
                    :checkbox-config="tableGrid.checkboxConfig"
                    :row-config="{ keyField: 'id' }"
                    @cell-click="handleRowClick"
                    @sort-change="handleSortChange"
                >

                    <template #toolbar_buttons>
                        <a-space>
                            <a-button @click="createTitle({ title_group_id: category.id, title_group_name: category.name })" v-if="accessToTitle('store')" >
                                添加标题
                            </a-button>
                            <a-button @click="create(category)" v-if="accessTo('update')" >
                                批量编辑
                            </a-button>
                            <a-button @click="batchCopyTitle" >
                                批量复制标题
                            </a-button>
                            <span v-if="selectedTitleCount > 0" style="color: red;">已选中标题 {{ selectedTitleCount }} 个</span>
                            <a-input placeholder="标题名称" v-model="queryParam.title_name" />
                            <a-button type="primary" @click="searchTitle">查询</a-button>
                            <a-button @click="resetTitleSearch">重置</a-button>
                        </a-space>
                    </template>
                    <!-- <template #toolbar_buttons>
                        <a-row type="flex" style="width: 80%;">
                            <a-col :span="22">
                                <a-space>
                                    <a-button @click="createTitle({ title_group_id: category.id, title_group_name: category.name })" v-if="accessToTitle('store')" >
                                        添加标题
                                    </a-button>
                                    <a-button @click="create(category)" v-if="accessTo('update')" >
                                        批量编辑
                                    </a-button>
                                    <a-button @click="batchCopyTitle" >
                                        批量复制标题
                                    </a-button>
                                    <span v-if="selectedTitleCount > 0" style="color: red;">已选中标题 {{ selectedTitleCount }} 个</span>
                                </a-space>
                            </a-col>
                            <a-col :span="2">
                                <a-space>
                                    <a-input placeholder="标题名称" v-model="queryParam.title_name" style="width: 200px;" />
                                    <a-button type="primary" @click="searchTitle">查询</a-button>
                                    <a-button @click="resetTitleSearch">重置</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </template> -->
                    

                    <template #name="{ row }">
                        <div  style="white-space: normal; word-break: break-all; text-align: left;">
                            <a href="javascript:;" @click="copyTitle(row.name, $event)">{{ row.name }}</a>
                        </div>
                    </template>
                    
                    <template #action="{ row }">
                        <div class="actions">
                            <template v-if="accessToTitle('update')">
                                <a href="javascript:;" @click="createTitle(row)">编辑</a>
                                <a-divider type="vertical" />
                                <a-popconfirm title="确认要删除吗?" @confirm="destroyTitle(row)" v-if="accessToTitle('destroy')">
                                    <a href="javascript:;">删除</a>
                                </a-popconfirm>
                            </template>
                            <template v-else>-</template>
                        </div>
                    </template>
                </vxe-grid>
            </a-tab-pane>
        </a-tabs>

        <create-form
            v-if="showForm"
            :showForm.sync="showForm"
            :model="model"
            @success="refresh"
        />
        
        <title-form
            v-if="titleForm"
            :titleForm.sync="titleForm"
            :model="model"
            @success="refresh"
        />
        
    </div>
</template>

<style lang="less" scoped>
@import 'TitleGroup';
</style>

<script>
import TitleGroup from './TitleGroup'
export default TitleGroup
</script>
